import React, { useState } from "react";
import { PaperPlaneRight } from "@phosphor-icons/react";

/** Bottom of the chat panel, text input, send button + "new chat" link. */
export default function ChatInput({ busy, onSend, onReset }) {
  const [text, setText] = useState("");

  const submit = () => {
    const t = text.trim();
    if (!t || busy) return;
    setText("");
    onSend(t);
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <>
      <div className="md-ai-foot">
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={onKey}
          placeholder="Ask about services, pricing, booking…"
          className="md-ai-input"
          data-testid="ai-chat-input"
          disabled={busy}
        />
        <button
          type="button"
          onClick={submit}
          disabled={busy || !text.trim()}
          className="md-ai-send"
          aria-label="Send"
          data-testid="ai-chat-send"
        >
          <PaperPlaneRight size={16} weight="fill" />
        </button>
      </div>
      <div className="md-ai-foot-meta">
        <button type="button" onClick={onReset} className="md-ai-reset" data-testid="ai-chat-reset">
          Start a new chat
        </button>
        <span>Powered by Claude · responses may need verification</span>
      </div>
    </>
  );
}
